import { ChangeDetectorRef, Directive, Renderer2 } from '@angular/core';

@Directive()
export abstract class BaseTooltipComponent {
  private unlisten: () => void;
  public isOpened = false;

  constructor(private readonly renderer: Renderer2, private readonly cdr: ChangeDetectorRef) {}

  private bindListener(toolTip: any, anchor: any): void {
    this.unlisten = this.renderer.listen('document', 'click', (event: MouseEvent) => {
      const targetElement = event.target;
      const clickedInside = anchor.contains(targetElement);

      if (toolTip && !clickedInside) {
        this.hideTooltip(toolTip);
      }
    });
  }

  public toggle(toolTip: any, anchor: any, event: TouchEvent | MouseEvent): void {
    event.stopPropagation();

    if (this.isOpened) {
      this.hideTooltip(toolTip);
    } else {
      this.bindListener(toolTip, anchor);
      toolTip.show(anchor);
      this.isOpened = true;
    }
  }

  private hideTooltip(toolTip: any): void {
    toolTip.hide();
    this.isOpened = false;
    this.unlisten();
    this.cdr.markForCheck();
  }
}
